
  const packingSlip = {
    path: "/worksheet/packing-slip/:id",
    name: "worksheetPackingSlip",
    component: () => import(/* webpackChunkName: "packing-slip" */ "@/components/packaging/PackingSlip.vue"),
    meta: { authorize: [], requiresAuth: true }
  };

export default packingSlip;
    